import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PermissionsEnum } from '../models/role.model';
import { DashboardConfiguration, UtilityLanguageSuffix } from '../models/utility.model';
// import { PermissionsService } from './permissions.service';
// import { ReportStateService } from '../components/reports/services/report-state.service';
import { Language } from '../models/user.model';
import { ResponsePackage } from '../models/util.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, 
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig, 
    private router: Router,
    private toastr: ToastrService,
    // public permissionsService: PermissionsService,
    // private reportStateService: ReportStateService,
    ) {  
      this.pathApi = this.config.pathApi + "auth/";
    }
  private jwtService = new JwtHelperService();


  login(email: string, password?: string, microsoftToken?: string): Observable<any> {
    return this.http.post(this.pathApi + "login", { Email: email, Password: password, MicrosoftToken: microsoftToken });
  } 

  tokenLogin(token: string): Observable<any> {
    return this.http.post(this.pathApi + "tokenLogin", { Token: token });
  }

  bpsLogin(email: string,pass: string, utilityId: string): Observable<any> {
    return this.http.post(this.pathApi + "bpsLogin", { Email: email, Password: pass, UtilityId: parseInt(utilityId) });
  } 

  getUtilityLoginData(): Observable<any> {
    return this.http.get(`${this.pathApi}getUtilityLoginData`, {
      headers: this.headers,
      observe: 'response',
    });
  } 

  bpsLoginFirstStep(email: string, utilityId: number): Observable<any> {
    return this.http.post(this.pathApi + "bpsLoginFirstStep", { Email: email, UtilityId: utilityId });
  } 

  logout(routeAfterClear : boolean) {
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('colorCode');
    localStorage.removeItem('configuration');
    localStorage.removeItem('imageUrl');
    localStorage.removeItem('filter');
    localStorage.removeItem('filterMeter');
    localStorage.removeItem('filterPole');
    localStorage.removeItem('filterTransformer');
    localStorage.removeItem('filterCustomer');
    localStorage.removeItem('filterBuilding'); 
    localStorage.removeItem('filterCustomer');
    localStorage.removeItem('filterBuilding');
    localStorage.removeItem('cameFrom');
    localStorage.removeItem('notVisibleFields');
    localStorage.removeItem('currency');
    localStorage.removeItem('mapConfiguration');
    localStorage.removeItem('preferredLanguage');
    localStorage.removeItem('languageSuffixes');
    // this.reportStateService.clearAllReportFilters({ clearMainTabSelection: true, clearDataQualityTabsSelection: true });

    window.sessionStorage.clear();
    // this.permissionsService.resetPermissions();
    if(routeAfterClear){
      this.router.navigate(['']);
    }
  }

  updateUserInLocalStorageNoApi(user: any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  private isWellFormedJwt(token: string | null): token is string {
    return !!token && token.split('.').length === 3;
  }

  isLoggedIn() {
    let token = localStorage.getItem('token');
    if (!this.isWellFormedJwt(token))
      return false;
    if(this.jwtService.isTokenExpired(token)){
      this.logout(true);
      this.toastr.error('Session timed out.');
    }
    return !this.jwtService.isTokenExpired(token);
  }

  public getCurrentUser() {
    let token = localStorage.getItem('token');
    if (!this.isWellFormedJwt(token))
      return null;

    return this.jwtService.decodeToken(token);
  }

  public isAuthorized(permission: PermissionsEnum) {
    let rolePermissions = localStorage.getItem('permissions');

    if (!rolePermissions) // dont have permissions on local storage
      return false;

      let permissions = rolePermissions ? JSON.parse(rolePermissions) : [];
      let filteredPerms = permissions.filter((x: any) => x == permission);

    if(filteredPerms)
      return filteredPerms[0];
    return null;
  }
  
  public hasConfiguration(config:any){
    let configuration = localStorage.getItem('configuration');
    if (!configuration){
      console.log('config null');
      return false;
    }

    let configurations = configuration ? JSON.parse(configuration) : [];
    return configurations.includes(config)
  }

  public get hasCimDataIntegration(): boolean {
    return this.hasConfiguration(DashboardConfiguration.CIMDataIntegration);
  }

  public hasUtility(){
    let token = localStorage.getItem('token');
    if (!this.isWellFormedJwt(token))
      return null;

    let currentUser = this.jwtService.decodeToken(token);
    return currentUser.utilityId != "";
  }

  public decodeJWTToken() {
    var token = localStorage.getItem('token');
    if (!this.isWellFormedJwt(token)){
      localStorage.removeItem('token');
      return null;
    } 
    const helper = new JwtHelperService();
    var decoded = helper.decodeToken(token);
    return decoded;
  }

  sendEmail(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}sendMessage`, obj)
  } 

  changePreferredLanguage(language: Language) {
    return this.http.post<ResponsePackage<UtilityLanguageSuffix[]>>(`${this.pathApi}changePreferredLanguage`, language)
  }

  getSas(containerName?: string): Observable<any> {
    return this.http.get(`${this.pathApi}sasToken`, {
      headers: this.headers,
      params: containerName ? { containerName } : {},
      observe: 'response',
    });
  }

  resendOTPCode(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}resendOTP`, dataIn);
  }

  verifyOTPCode(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}verifyOTP`, dataIn);
  }
}
